@if (dataView) {
  <div class="trip_package fx-column">
    <div class="label">{{'Treno' | translate}} @if (dataView.returnTravelSolution) {
      <span>(A/R)</span>
    }</div>
    <div class="fx-column">
      <div
        class="value">{{ inputTripBookingPackage.external_solution_data.travel.travelSolutions[0].start.stationName }}
        <mat-icon style="vertical-align: middle">chevron_right</mat-icon>
        {{ dataView.end.stationName }}
      </div>
      @if (isCarnet) {
        <span class='h4 secondary-text'>
          <span style="color: darkred"> CARNET VIAGGI </span>
        </span>
      }
      @if (!inputTripBookingPackage.target_info.orderType || !isCarnet) {
        <div>
          {{ dataView.departure | date: 'dd/MM/yyyy HH:mm'}}
          -
          {{ dataView.arrival | date: 'HH:mm' }}
        </div>
      }
      @if (status==='canceled') {
        <div>
          <strong>
            <span style="color:red"> CANCELLATO </span>
          </strong>
        </div>
      }
      @if (status==='refunded') {
        <div>
          <strong>
            <span style="color:red"> RIMBORSATO </span>
          </strong>
        </div>
      }
    </div>
    @if (dataView.returnTravelSolution) {
      <div class="fx-column">
        <br>
          <div
            class="value">{{ dataView.returnTravelSolution.start.stationName }}
            <mat-icon style="vertical-align: middle">chevron_right</mat-icon>
            {{ dataView.returnTravelSolution.end.stationName }}
          </div>
          @if (isCarnet) {
            <span class='h4 secondary-text'>
              <span style="color: darkred"> CARNET VIAGGI </span>
            </span>
          }
          @if (!inputTripBookingPackage.target_info.orderType || !isCarnet) {
            <div>
              {{ dataView.returnTravelSolution.departure | date: 'dd/MM/yyyy HH:mm'}}
              -
              {{ dataView.returnTravelSolution.arrival | date: 'HH:mm' }}
            </div>
          }
          @if (status==='canceled') {
            <div>
              <strong>
                <span style="color:red"> CANCELLATO </span>
              </strong>
            </div>
          }
          @if (status==='refunded') {
            <div>
              <strong>
                <span style="color:red"> RIMBORSATO </span>
              </strong>
            </div>
          }
        </div>
      }
      <div class="value price"
        [ngClass]="{'del': status=='canceled' || status=='refunded'}"
        matTooltip="{{totalFee>0?'Prezzo:'+(totalRowLordo-totalFee| currency:'EUR':'symbol':'1.2-2')+' + Diritti agenzia:'+(totalFee | currency:'EUR':'symbol':'1.2-2'):''}}">
        {{totalRowLordo | currency:'EUR' }}
      </div>
      @if (status=='confirmed') {
        <span class="fx-row fx-justify-start fx-items-center" style="gap: 8px">
          <i class="material-icons-outlined">download</i>
          <a class="download-ticket"
            [href]='appService.getBaseServerAddressRoot() + "/download-ticket/by/id/" + inputTripBookingPackage.id'
          target="_blank">{{'Scarica Biglietti' | translate}}</a>
        </span>
      }
    </div>
  }
